export default __webpack_public_path__ + "static/media/baby.d983fa1b.png";